$(document).ready(function () {
  // if ($('.yotpo-bottomline').length) {
  //      setTimeout(function() {

  //        $.each($('.yotpo-bottomline'), function() {
  //            var prod_id = $(this).attr('data-id');
  //            // yotpo.fetch("reviews", {
  //            //     product_id: prod_id
  //            // }).then(function(data) {
  //            //   console.log(data);
  //            // });
  //        });
  //      }, 1500);
  //    }

  $(".like-button").on("click", function () {
    $(this).toggleClass("liked-button");
  });

  // $('#submit_form_anchor').on('click', function() {
  //     $(this).closest('form').submit();
  // });

  $("body").on("click", ".atc-new-ajax3", function () {
    var form = $(this).closest("form");

    $("html, body").animate(
      {
        scrollTop: 0,
      },
      320
    );

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: form.serialize(),
      success: function (product) {
        // var cart_items = parseInt($('.cart_header_link .qt-desk').html());
        // cart_items++;
        // $('.cart_header_link .qt-desk').html(cart_items);
        // $('.cart_sticky_link .qt-desk').html(cart_items);
        // $('.cart_header_link').addClass('shake-anim');
        // setTimeout(function() {
        //   $('.cart_header_link').removeClass('shake-anim');
        // }, 2000);
        // $('.qt-desk').show().addClass('bounce2');
        window.location.href = "/cart";
      },
      error: function (resp) {
        // alert(resp.responseJSON.description);
        // $('.modal').html('The product you are trying to add is out of stock.');
      },
    });
  });

  $("body").on("click", ".atc-new-ajax2", function () {
    var form = $(this).parent().prev();
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: form.serialize(),
      success: function (product) {
        // var qty1 = parseInt($(".qt-mobile").text());
        // qty1++;
        // $(".qt-mobile").html(qty1);
        // $(".modal").html(product.title + " was added to the cart!");
        // var cart_items = parseInt($(".cart_header_link .qt-desk").html());
        // cart_items++;
        // $(".cart_header_link .qt-desk").html(cart_items);
        // $(".cart_sticky_link .qt-desk").html(cart_items);
        //            	alert('product added to cart');
        window.location.href = "/cart";
      },
      error: function (resp) {
        // $('.modal').html('The product you are trying to add is out of stock.');
      },
    });
  });

  //   cpdp mobile
  $(".cpdp-prod-option-changer").on("change", function () {
    var merged_arr = [];
    $.each(
      $(this).closest("form").find(".cpdp-prod-option-changer"),
      function () {
        merged_arr.push($(this).val());
      }
    );

    var merged_str = merged_arr.join(" / ");

    var found1 = false;
    var closest_select = $(this)
      .closest("form")
      .find(".cpdp-product-all-variants");
    if (!closest_select.length) {
      closest_select = $("#make-it-combo-all-variants");
    }
    $.each(closest_select, function () {
      var this_sel = $(this);
      $.each($(this).find("option"), function () {
        console.log($(this).html().trim());
        console.log(merged_str);
        if ($(this).html().trim() == merged_str) {
          this_sel.val($(this).val()).trigger("change");
          var compare = this_sel.find(":selected").attr("data-compare");
          var price = this_sel.find(":selected").attr("data-price");
          compare = parseInt(compare) / 100;
          price = parseInt(price) / 100;
          this_sel
            .closest(".slp-holder")
            .find(".p_compare_price")
            .html("<sup>$</sup>" + compare + "<sup>00</sup>");
          this_sel
            .closest(".slp-holder")
            .find(".p_price")
            .html("<sup>$</sup>" + price + "<sup>00</sup>");
          found1 = true;
          return false;
        }
      });
    });
    if (!found1) {
      // alert(merged_str+' is out of stock.');
    }

    if ($(this).val() == "Medium Soft") {
      $(this).closest(".slp-holder").find(".slp-type").hide();
      $(this).closest(".slp-holder").find(".general-sleeper").show();
      $(this).closest(".slp-holder").find(".side-sleeper").show();
    }
    if ($(this).val() == "Medium Firm") {
      $(this).closest(".slp-holder").find(".slp-type").hide();
      $(this).closest(".slp-holder").find(".general-sleeper").show();
      $(this).closest(".slp-holder").find(".side-sleeper").show();
      $(this).closest(".slp-holder").find(".stomach-sleeper").show();
      $(this).closest(".slp-holder").find(".back-sleeper").show();
    }
    if ($(this).val() == "Firm") {
      $(this).closest(".slp-holder").find(".slp-type").hide();
      $(this).closest(".slp-holder").find(".general-sleeper").show();
      $(this).closest(".slp-holder").find(".stomach-sleeper").show();
      $(this).closest(".slp-holder").find(".back-sleeper").show();
    }
    if ($(this).val() == "Extra Firm") {
      $(this).closest(".slp-holder").find(".slp-type").hide();
      $(this).closest(".slp-holder").find(".stomach-sleeper").show();
      $(this).closest(".slp-holder").find(".back-sleeper").show();
    }
  });
  $(".cb12_prod .single-option-selector").on("change", function () {
    if ($(this).val() == "Medium Soft") {
      $(".sleeper-types-desk2").find(".slp-type").hide();
      $(".sleeper-types-desk2").find(".general-sleeper").show();
      $(".sleeper-types-desk2").find(".side-sleeper").show();
    }
    if ($(this).val() == "Medium Firm") {
      $(".sleeper-types-desk2").find(".slp-type").hide();
      $(".sleeper-types-desk2").find(".general-sleeper").show();
      $(".sleeper-types-desk2").find(".side-sleeper").show();
      $(".sleeper-types-desk2").find(".stomach-sleeper").show();
      $(".sleeper-types-desk2").find(".back-sleeper").show();
    }
    if ($(this).val() == "Firm") {
      $(".sleeper-types-desk2").find(".slp-type").hide();
      $(".sleeper-types-desk2").find(".general-sleeper").show();
      $(".sleeper-types-desk2").find(".stomach-sleeper").show();
      $(".sleeper-types-desk2").find(".back-sleeper").show();
    }
    if ($(this).val() == "Extra Firm") {
      $(".sleeper-types-desk2").find(".slp-type").hide();
      $(".sleeper-types-desk2").find(".stomach-sleeper").show();
      $(".sleeper-types-desk2").find(".back-sleeper").show();
    }
  });

  $(".cart_header_link").on("click", function (e) {
    e.preventDefault();
    $(".hs-cart-drawer-0").toggleClass("hs-active");
  });

  $(".product__quantity__btn--down").click(function () {
    var t = $("#quantity").val();
    if (t > 1) {
      t--;
      $("#quantity").val(t);
    }
  }),
    $(".product__quantity__btn--up").click(function () {
      var t = $("#quantity").val();
      t++;
      $("#quantity").val(t);
    });

  // why us page

  if ($(".why__boxes .why__box").length) {
    $(".why__boxes .why__box:not(a)").on("click", function () {
      var a_href = $(this).find("a").attr("href");
      console.log("clicked");
      $("html, body").animate(
        {
          scrollTop: $(a_href).offset().top - 90,
        },
        10
      );
    });
  }

  // how to mattress finder page
  $(".first-q-btn").click(function (e) {
    $(".first-q-btn").removeClass("selected_option");
    $(this).addClass("selected_option");
    $("#type-1").addClass("show");
  });

  $("#accordionOne a").click(function (e) {
    $("#accordionOne a").removeClass("selected_option");
    $(this).addClass("selected_option");

    var id = $(this).attr("href");
    // calculate result
    var first_answer = $(".first-q-btn.selected_option").attr("data-select");
    var second_answer = $("#accordionOne .selected_option").attr("data-select");

    $("#fm-1").hide().removeClass("show");
    $("#fm-2").hide().removeClass("show");
    $("#fm-3").hide().removeClass("show");
    switch (first_answer) {
      case "back_side":
        if (second_answer == "light") {
          if ($("#fm-1").hasClass("show")) {
          } else {
            $("#fm-1").show().addClass("show");
          }
          $("html, body").animate(
            {
              scrollTop: $("#fm-1").offset().top,
            },
            600
          );
        } else if (second_answer == "average") {
          if ($("#fm-2").hasClass("show")) {
          } else {
            $("#fm-2").show().addClass("show");
          }

          $("html, body").animate(
            {
              scrollTop: $("#fm-2").offset().top,
            },
            600
          );
        } else if (second_answer == "heavy") {
          if ($("#fm-2").hasClass("show")) {
          } else {
            $("#fm-2").show().addClass("show");
          }

          $("html, body").animate(
            {
              scrollTop: $("#fm-2").offset().top,
            },
            600
          );
        }
        break;
      case "side":
        if (second_answer == "light") {
          if ($("#fm-3").hasClass("show")) {
          } else {
            $("#fm-3").show().addClass("show");
          }

          $("html, body").animate(
            {
              scrollTop: $("#fm-3").offset().top,
            },
            600
          );
        } else if (second_answer == "average") {
          if ($("#fm-1").hasClass("show")) {
          } else {
            $("#fm-1").show().addClass("show");
          }

          $("html, body").animate(
            {
              scrollTop: $("#fm-1").offset().top,
            },
            600
          );
        } else if (second_answer == "heavy") {
          if ($("#fm-1").hasClass("show")) {
          } else {
            $("#fm-1").show().addClass("show");
          }

          $("html, body").animate(
            {
              scrollTop: $("#fm-1").offset().top,
            },
            600
          );
        }
        break;
      case "general":
        if (second_answer == "light") {
          if ($("#fm-1").hasClass("show")) {
          } else {
            $("#fm-1").show().addClass("show");
          }

          $("html, body").animate(
            {
              scrollTop: $("#fm-1").offset().top,
            },
            600
          );
        } else if (second_answer == "average") {
          if ($("#fm-1").hasClass("show")) {
          } else {
            $("#fm-1").show().addClass("show");
          }

          $("html, body").animate(
            {
              scrollTop: $("#fm-1").offset().top,
            },
            600
          );
        } else if (second_answer == "heavy") {
          if ($("#fm-2").hasClass("show")) {
          } else {
            $("#fm-2").show().addClass("show");
          }

          $("html, body").animate(
            {
              scrollTop: $("#fm-2").offset().top,
            },
            600
          );
        }
        break;
    }

    // if ($(id).hasClass('show')) {
    //   $('html, body').animate({
    //     scrollTop: $(id).offset().top
    //   }, 600);
    // } else {
    //   $(id).collapse('show');
    // }
    e.preventDefault();
  });

  $(".js-recommended .collapse").each(function (i, e) {
    $(e)
      .on("show.bs.collapse", function () {
        $(".answers .collapse.show").hide();
      })
      .on("shown.bs.collapse", function () {
        $("html, body").animate(
          {
            scrollTop: $(e).offset().top - 70,
          },
          600
        );
      });
  });

  // Questions page
  if ($(".products-list-for-questions").length) {
    $(".products-list-for-questions article").on("click", function () {
      var title = $(this).find(".tile-prod-title").html();
      $(".prod-title-modal").html(title);

      $(".modal-prod-link").attr("href", $(this).attr("data-href"));
      $(".modal-shipping-btn").attr(
        "href",
        $(this).attr("data-href") + "#shipping"
      );
      $(".modal-warranty-btn").attr(
        "href",
        $(this).attr("data-href") + "#warranty"
      );

      $("#product_details_modal .enrty__content2").html("");
      var questions = $(this).find(".questions-hidden").html();
      $("#product_details_modal .enrty__content2").html(questions);
      $("#product_details_modal").modal("show");
    });

    $("#questions-search-input").on("keyup", function () {
      $(".no-q-found").hide();
      var search_query = $(this).val().toLowerCase();
      if (!search_query) {
        $("#dimensions").show();
        $(".searchable-questions li.font-size-lg").show();
        $.each($(".searchable-questions li.font-size-lg"), function () {
          $(this).show();
          $(this).next().show();
        });
      } else {
        var no_results = true;
        $("#dimensions").hide();
        $.each($(".searchable-questions li.font-size-lg"), function () {
          var this_text = $(this).html().toLowerCase();
          var next_text = $(this).next().html().toLowerCase();
          if (
            this_text.indexOf(search_query) >= 0 ||
            next_text.indexOf(search_query) >= 0
          ) {
            $(this)[0].style.setProperty("display", "flex", "important");
            $(this).next()[0].style.setProperty("display", "flex", "important");
            no_results = false;
          } else {
            $(this)[0].style.setProperty("display", "none", "important");
            $(this).next()[0].style.setProperty("display", "none", "important");
          }
        });
        if (no_results) {
          $(".no-q-found").show();
        } else {
          $(".no-q-found").hide();
        }
      }
    });
  }

  $(".mobile_submenu_opener").on("click", function () {
    $(this).parent().find(".menu__submenu").slideToggle();
  });
});
